import { render, staticRenderFns } from "./aRateDashboardResume.vue?vue&type=template&id=e10d2d2a&scoped=true"
import script from "./aRateDashboardResume.vue?vue&type=script&lang=js"
export * from "./aRateDashboardResume.vue?vue&type=script&lang=js"
import style0 from "./aRateDashboardResume.vue?vue&type=style&index=0&id=e10d2d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10d2d2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow,VSkeletonLoader})
